import { configFetch as fetch } from '@meiqia/utils';

const getEntUrl = (source, subSource) => {
  let url = '/agent/enterprise_config';
  if (source && subSource) {
    url = `${url}?source=${source}&sub_source_name=${subSource}`;
  }
  return url;
};

export const getEnterpriseConfigApi = (source, subSource) => {
  return fetch({
    url: getEntUrl(source, subSource),
    method: 'get'
  });
};

export const updateEnterpriseConfigApi = (data, source, subSource) => {
  return fetch({
    url: getEntUrl(source, subSource),
    method: 'post',
    data
  });
};
